import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import UnitRatingsList from './UnitRatingsList';
import UnitRatingListService from '../../services/UnitRatingListService';

class UnitRatingsListContainer extends Component {
  componentDidMount() {
    UnitRatingListService.init();
  }

  render() {
    return (
      <UnitRatingsList units={toJS(UnitRatingListService.units)} fetching={UnitRatingListService.fetch.fetching} />
    );
  }
}

export default observer(UnitRatingsListContainer);
